"use client";

import { Box, Flex } from "@thenounproject/lingo-core";
import React from "react";
import styled from "styled-components";
import { MobileMenuItem } from "./Header";
import { HEADER_HEIGHT, MOBILE_NAV_WIDTH, DROPDOWN_OFFSET } from "./constants";
import { MARKETING_BP_MD } from "../utils/constants";
import MobileMenuSection from "./MobileMenuSection";
import CtaButtonComponent from "./CtaButtons";
import { useIsScrolled } from "./DesktopNav";

const MobileNav = styled(Flex)<{ $shown: boolean; isScrolled?: boolean }>`
  position: fixed;
  top: ${props => HEADER_HEIGHT + DROPDOWN_OFFSET - (props.isScrolled ? 27 : 0)}px;
  bottom: 0;
  right: 0;
  transform: translateX(${props => (props.$shown ? "0" : "100%")});
  width: ${MOBILE_NAV_WIDTH}px;
  max-width: 100%;
  z-index: 999999;
  height: calc(100vh - ${HEADER_HEIGHT}px);
  overflow: auto;
  transition: transform 0.4s ease;
  background: white;
  padding: 16px 40px;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${MARKETING_BP_MD}) {
    display: none;
  }

  @media (max-width: ${MOBILE_NAV_WIDTH}px) {
    box-shadow: none;
  }
`;

type Props = {
  showMenu: boolean;
  mobileMenuItems: MobileMenuItem[];
  mobileMenuRef: React.RefObject<HTMLElement>;
  mobileItemOpen: string | null;
  setMobileItemOpen: (id: string | null) => void;
};
export default function MobileNavComponent({
  showMenu,
  mobileMenuItems,
  mobileMenuRef,
  mobileItemOpen,
  setMobileItemOpen,
}: Props) {
  const isScrolled = useIsScrolled();
  return (
    <MobileNav
      as="nav"
      role="navigation"
      ref={mobileMenuRef}
      $shown={showMenu}
      isScrolled={isScrolled}>
      <Box mt="10px" className="mobile-nav-items">
        <Flex flexDirection="column" gap="16px" textAlign="left">
          {mobileMenuItems.map(item => (
            <MobileMenuSection
              key={item.id}
              item={item}
              isOpen={mobileItemOpen === item.id}
              onToggle={() => setMobileItemOpen(mobileItemOpen === item.id ? null : item.id)}
            />
          ))}
        </Flex>
      </Box>
      <Box className="mobile-nav-buttons">
        <CtaButtonComponent isMobile={true} />
      </Box>
    </MobileNav>
  );
}
